import * as yup from "yup";

const max_chats = yup
  .number()
  .typeError("Value must be a number")
  .min(1, "Minimum 1")
  .max(20, "Maximum 20");

export const schemaAction = yup.object().shape({
  field: yup.string(),
  externalaccess: yup.boolean(),
  max_chats: max_chats.when("field", {
    is: "maxchat",
    then: max_chats.required("Max Chat is required1"),
    otherwise: max_chats,
  }),
  skills: yup.array().of(yup.string()).nullable(),
  addedskills: yup.array().of(yup.string()).nullable(),
  commonskills: yup.array().of(yup.string()).nullable(),
  commonsremoved: yup.array().of(yup.string()).nullable(),
});
